import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import template from '../../templates/FeatureInclusion/Index.rt';
import featureInclusionHeader from '../../templates/FeatureInclusion/Header.rt';
import featureInclusionSubHeader from '../../templates/FeatureInclusion/SubHeader.rt';
import * as actions from '../../actions';
import {hashHistory} from 'react-router';

function mapStateToProps(state, props) {
  const PAGE_LENGTH = 25;
  const { featureInclusionData, page, selectedPreset, searchTerm } = state.featureInclusion;
  const { checkedFeatureGroups } = state.featureInclusion.featureSelection;
  let filteredData = featureInclusionData;
  if(searchTerm && _.trim(searchTerm).length > 0) {
    filteredData = featureInclusionData.filter((d) => {
      return _.includes(d.name, searchTerm);
    });
  }
  let pagedFeatureInclusionData = _.chunk(filteredData, PAGE_LENGTH)[page];
  let totalPages = Math.ceil((filteredData || []).length / PAGE_LENGTH);
  return {
    featureInclusionData,
    filteredData,
    pagedFeatureInclusionData,
    totalPages,
    page,
    selectedPreset,
    checkedFeatureGroups
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    loadPresets: () => dispatch(actions.featureInclusion.loadPresets()),
    deletePreset: (id) => dispatch(actions.featureInclusion.deletePreset(id)),
    showAddNewPresetPopup: () => dispatch(actions.featureInclusion.showAddNewPresetPopup(true)),
    setpage: (page) => dispatch(actions.featureInclusion.setPage(page)),
    selectPreset: (id, setOnly) => dispatch(actions.featureInclusion.selectPreset(id, setOnly)),
    setSearchTerm: (term) => dispatch(actions.featureInclusion.setSearchTerm(term)),
    updatePresetValue: (id, key, value) => dispatch(actions.featureInclusion.updatePresetValue(id, key, value)),
    showAddAssigneePopup: () => dispatch(actions.featureInclusion.showAddAssigneePopup(true))
  };
}

class featureInclusion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: props.page
    };
  }
  componentWillMount() {
    this.props.loadPresets();
  }
  render = template;

  setPage = (page) => {
    this.setState({page}, () => this.props.setPage(page));
  }

  updatePresetValue = (key, e) => {
    if(this.props.selectedPreset) {
      this.props.updatePresetValue(this.props.selectedPreset, key, e.target.value);
    }
  }

  showAddAssignees = (id) => {
    this.props.selectPreset(id, true)
      .then(this.props.showAddAssigneePopup());
  }

  editPreset = (id) => {
    this.props.selectPreset(id, true)
      .then(() => hashHistory.push('/featureSelection'));
  }

  getUniqueFeatures = (features) => {
    var uniqueFeatureList = [];
    if(features) {
      for(var i = 0; i < features.length; i++) {
        var eIndex = _.findIndex(uniqueFeatureList, fl => { return fl.name == features[i].name; })
        if(eIndex == -1) {
          uniqueFeatureList.push(features[i]);
        }
      }
      uniqueFeatureList.sort((a, b) => {
        let aName = _.trim(a.name).toLowerCase()
          , bName = _.trim(b.name).toLowerCase();
        if(aName < bName)
          return -1;
        else if(aName > bName)
          return 1;
        return 0;
      });
    }
    
    let filteredUniqueFeatureList = uniqueFeatureList.filter(f => {
      for(var i = 0; i < this.props.checkedFeatureGroups.length; i++) {
        var fg = this.props.checkedFeatureGroups[i];
        if(_.startsWith(f.name.toLowerCase(), fg.toLowerCase())) {
          return true;
        }
      }
      return false;
    });
    return filteredUniqueFeatureList;
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
const FeatureInclusion = connector(featureInclusion);
const FeatureInclusionHeader = connector(featureInclusionHeader);
const FeatureInclusionSubHeader = connector(featureInclusionSubHeader);

export {FeatureInclusion, FeatureInclusionHeader, FeatureInclusionSubHeader};
